/**
 * Input Schema of MotoristaMensagemPush
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {MotoristaMensagemPush} from '@/model/resource/MotoristaMensagemPush'
import {MotoristaCollection} from '@/model/collection/MotoristaCollection'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'

/* TODO: review generated schema */
export class InputMotoristaMensagemPushSchema extends Schema {
  collectionMotorista = new MotoristaCollection().noPagination()
  collectionResponsavel = new ResponsavelCollection().noPagination()

  readonly name = 'InputMotoristaMensagemPush'

  readonly fieldSet: FieldSet<MotoristaMensagemPush> = {
    motorista: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionMotorista.all(),
      },
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionResponsavel.all(),
      },
    }),
    mensagem: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 1023,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    data: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'datetime',
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
    lida: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
  }
}
